import { Form, Tooltip } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { AppModalShellGlobalStyles } from '@/components/ui/AppModalShellStyles';
import { ViewModeSegmented } from '@/components/ui/ViewModeSegmented';
import { AppSelect } from '@/components/ui/AppSelect';
import { Button } from '@components/ui/Button';
import { DashboardContainer, StudentsHeaderActions, StudentsHeaderLeft, StudentsHeaderRow, StudentsHeaderSub, StudentsHeaderTitle } from './style';
import ClassesSubjectsClasses from './ClassesSubjectsClasses';
import BadgeManagement from './BadgeManagement';

/**
 * Classes & Badge shell — UI only (no hooks). Props from `useClassesSubjectsShell`.
 */
export default function ClassesSubjectsView({
    activeTab,
    setActiveTab,
    classesScreen,
    badgeScreen,
    classesCampusPickList,
    classesBranchOptions,
    classesBranchTableFilter,
    setClassesBranchTableFilter,
    openCreateClass,
    classesLimitExceeded,
    badgesLimitExceeded,
}) {
    return (
        <DashboardContainer>
            <AppModalShellGlobalStyles />
            <StudentsHeaderRow>
                <StudentsHeaderLeft>
                    <StudentsHeaderTitle>Classes & Badge</StudentsHeaderTitle>
                    <StudentsHeaderSub>
                        {activeTab === 'classes'
                             ? 'Manage classes, their subjects, and campuses. Open a class to see subjects — use Unassign on a row (or clear the teacher when editing) before deactivating or removing a teacher from the directory.'
                             : 'Badge management — cohort badges are per campus (same branches as School Time). Filter by campus or create a badge for one campus.'}
                    </StudentsHeaderSub>
                </StudentsHeaderLeft>
                <StudentsHeaderActions>
                    {activeTab === 'classes' ? (
                        <>
                            {classesCampusPickList.length ? (
                                <Form.Item label="Campus" style={{ marginBottom: 0, minWidth: 200 }}>
                                    <AppSelect
                                        allowClear={false}
                                        placeholder="All campuses"
                                        value={classesBranchTableFilter}
                                        onChange={setClassesBranchTableFilter}
                                        options={[
                                            { value: '__all__', label: 'All campuses' },
                                            ...classesBranchOptions,
                                        ]}
                                    />
                                </Form.Item>
                            ) : null}
                            <Tooltip title={classesLimitExceeded ? "Limit is exceeded. Please contact EDULINK to change your Subscription Plan." : ""}>
                                <Button
                                    type="primary"
                                    icon={<PlusOutlined />}
                                    onClick={openCreateClass}
                                    disabled={classesLimitExceeded}
                                >
                                    Create class
                                </Button>
                            </Tooltip>
                        </>
                    ) : null}
                    {activeTab === 'badges' ? (
                        <>
                            {badgeScreen.campusPickList.length ? (
                                <Form.Item label="Campus" style={{ marginBottom: 0, minWidth: 200 }}>
                                    <AppSelect
                                        allowClear={false}
                                        placeholder="All campuses"
                                        value={badgeScreen.badgeBranchTableFilter}
                                        onChange={badgeScreen.setBadgeBranchTableFilter}
                                        options={[
                                            { value: '__all__', label: 'All campuses' },
                                            ...badgeScreen.branchOptions,
                                        ]}
                                    />
                                </Form.Item>
                            ) : null}
                            <Tooltip title={badgesLimitExceeded ? "Limit is exceeded. Please contact EDULINK to change your Subscription Plan." : ""}>
                                <Button
                                    type="primary"
                                    icon={<PlusOutlined />}
                                    onClick={badgeScreen.openCreateModal}
                                    disabled={badgesLimitExceeded}
                                >
                                    Create badge
                                </Button>
                            </Tooltip>
                        </>
                    ) : null}
                </StudentsHeaderActions>
            </StudentsHeaderRow>

            <ViewModeSegmented
                value={activeTab}
                onChange={setActiveTab}
                options={[
                    { value: 'classes', label: 'Classes & subjects' },
                    { value: 'badges', label: 'Badge management' },
                ]}
            />

            {activeTab === 'classes' ? (
                <ClassesSubjectsClasses screen={classesScreen} />
            ) : (
                <BadgeManagement screen={badgeScreen} />
            )}
        </DashboardContainer>
    );
}
